import gsap from 'gsap';
import Dispatch from '../core/Dispatch';
import { COMPONENT_INIT } from '../lib/events';

export default (el, props) => {

    const buttons = el.querySelectorAll('button[aria-controls]');
    const { intervalDuration = 8 } = props || {};

    let timeline;
    let observer;
    let hasClicked = false;

    let createTimelineHandler;

    const getCurrentArticle = () => el.querySelector('article:not([hidden])');

    const changeArticle = id => {
        const currentArticle = getCurrentArticle();
        if (currentArticle.id === id) {
            return;
        }

        const newArticle = document.getElementById(id);
        if (!newArticle) {
            console.warn(`Article with ID ${id} not found`);
            return;
        }

        currentArticle.hidden = true;
        newArticle.hidden = false;

        el.querySelectorAll('button[aria-controls]')
            .forEach(button => {
                if (button.getAttribute('aria-controls') === id) {
                    button.setAttribute('aria-current', 'true');
                } else {
                    button.removeAttribute('aria-current');
                }
            });

        if (hasClicked) {

        } else {
            createTimelineHandler();
        }
    };

    const nextArticle = () => {
        const articles = [...el.querySelectorAll('article[id]')];
        if (articles.length <= 1) {
            return;
        }
        const currentArticle = el.querySelector('article:not([hidden])');
        const currentArticleIndex = articles.indexOf(currentArticle);
        const nextArticleIndex = (currentArticleIndex + 1) % articles.length;
        const nextArticleId = articles[nextArticleIndex].id;
        changeArticle(nextArticleId);
    };

    const killTimeline = () => {
        if (!timeline) {
            return;
        }
        timeline.kill();
        timeline = null;

        const overlays = el.querySelectorAll('button[aria-controls] [data-overlay]');
        gsap.to(overlays, { scaleY: 1, duration: 0.3 });
    };

    const createTimeline = () => {
        killTimeline();

        const currentButtonOverlay = el.querySelector('button[aria-controls][aria-current="true"] [data-overlay]');

        timeline = gsap.timeline({
            onComplete() {
                nextArticle();
            }
        })
            .fromTo(currentButtonOverlay, {
                scaleY: 0
            }, {
                scaleY: 1,
                duration: intervalDuration,
                transformOrigin: 'center top',
                ease: 'none'
            });
    };

    createTimelineHandler = createTimeline;

    const onButtonClick = e => {
        hasClicked = true;
        killTimeline();
        changeArticle(e.currentTarget.getAttribute('aria-controls'));
    };

    const onButtonOrLinkMouseEnter = () => {
        if (timeline) {
            timeline.pause();
        }
    };

    const onButtonOrLinkMouseLeave = () => {
        if (timeline) {
            timeline.play();
        }
    };

    const init = () => {
        if (buttons.length > 1) {
            buttons
                .forEach(button => {
                    button.addEventListener('click', onButtonClick);
                });

            observer = new IntersectionObserver(([{ isIntersecting }]) => {
                if (isIntersecting) {
                    createTimeline();
                    timeline.play();
                } else {
                    killTimeline();
                    hasClicked = false;
                }
            });
            observer.observe(el);

            el.querySelectorAll('a,button').forEach(buttonOrLink => {
                buttonOrLink.addEventListener('mouseenter', onButtonOrLinkMouseEnter);
                buttonOrLink.addEventListener('mouseleave', onButtonOrLinkMouseLeave);
            });

            createTimeline();
        }

        Dispatch.emit(COMPONENT_INIT);
    };

    const destroy = () => {
        if (buttons.length <= 1) {
            return;
        }

        killTimeline();

        buttons
            .forEach(button => {
                button.removeEventListener('click', onButtonClick);
            });

        el.querySelectorAll('a,button').forEach(buttonOrLink => {
            buttonOrLink.addEventListener('mouseenter', onButtonOrLinkMouseEnter);
            buttonOrLink.addEventListener('mouseleave', onButtonOrLinkMouseLeave);
        });

        if (observer) {
            observer.disconnect();
            observer = null;
        }
    };

    return {
        init,
        destroy
    };

};
